export default __webpack_public_path__ + "a9ef62c29dda6f3770c46031890c7150.jpg";